// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../primitives/Json.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function decodeStreet(establishment) {
  let part = name => Stdlib_Option.filter(Stdlib_Option.map(Stdlib_Option.orElse(Json.flatDecodeDictFieldString(establishment, name), Stdlib_Option.map(Json.flatDecodeDictFieldFloat(establishment, name), name => name.toString())), prim => prim.trim()), value => value !== "");
  let parts = Stdlib_Array.filterMap([
    part("numero_voie"),
    part("indice_repetition"),
    part("type_voie"),
    part("libelle_voie")
  ], value => value);
  if (parts.length !== 0) {
    return parts.join(" ");
  }
  let adresse = Stdlib_Option.mapOr(Json.flatDecodeDictFieldString(establishment, "adresse"), "", prim => prim.trim());
  let trailing = Stdlib_Array.filterMap([
    part("code_postal"),
    part("libelle_commune")
  ], value => value).join(" ");
  if (trailing === "") {
    return adresse;
  } else {
    return adresse.replace(trailing, "").trim();
  }
}

function decodeDirector(company) {
  return Stdlib_Option.flatMap(Json.flatDecodeDictFieldArray(company, "dirigeants"), directors => Stdlib_Array.findMap(directors, director => {
    let director$1 = Json.decodeDict(director);
    let match = Stdlib_Option.flatMap(Json.flatDecodeDictFieldString(director$1, "prenoms"), firstNames => firstNames.split(" ")[0]);
    let match$1 = Json.flatDecodeDictFieldString(director$1, "nom");
    if (match !== undefined && match$1 !== undefined && match !== "" && match$1 !== "") {
      return [
        match,
        match$1
      ];
    }
  }));
}

export {
  decodeStreet,
  decodeDirector,
}
/* No side effect */
